module.exports = __webpack_public_path__ + "img/yingyanfooter.3b2637ed.png";